export default function DownloadBanner() {
  return (
    <section id="download" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 xl:px-14">
        <div className="relative rounded-lg overflow-hidden border border-background-200 reveal reveal-1">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20soft%20warm%20gradient%20background%20with%20subtle%20flowing%20translucent%20shapes%20and%20gentle%20light%2C%20minimal%20editorial%20composition%2C%20amber%20and%20cream%20tones%20with%20hints%20of%20green%2C%20clean%20spacious%2C%20no%20text%2C%20no%20objects&width=1600&height=640&seq=91br-cta-bg&orientation=landscape"
              alt="91浏览器最新版下载引导背景"
              title="91浏览器最新版下载"
              className="w-full h-full object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/55 to-foreground-950/30"></div>
          </div>

          <div className="relative px-6 py-14 md:px-16 md:py-20 max-w-2xl">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50 leading-snug">
              选好版本，现在就把 91浏览器装进手机
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-100/90 leading-relaxed">
              无论是安卓版、最新版还是离线安装包，安装流程都只有三步。装完再回头看，内存小和看片卡顿其实都不是难题。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-3 md:gap-4">
              <a
                href="#versions"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载安卓版
              </a>
              <a
                href="#versions"
                className="inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 border border-background-50/40 text-background-50 font-medium px-6 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
              >
                <i className="ri-file-zip-line text-lg"></i>
                获取安装包
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}